<template>
    <div
        data-interface-section="my-games"
        :class="$style.games"
    >
        <BaseLink
            :to="{ name: ROUTE_NAMES.PROFILE }"
            :class="['sqrcl', $style.my_games_link]"
        >
            <Typography
                type="caption"
                size="xs"
                accent
                :class="$style.my_games_link_label"
            >
                {{ $tr('myGames.title') }}
            </Typography>
            <Icon name="caret-right" />
        </BaseLink>
        <GameCard
            v-for="(game, index) in games"
            :key="index"
            :classForGame="$style.game"
            :game="game"
            :targetLink="gameLinkTarget"
            :to="gameAutoplayStore.getMyGamesLink(game.hru)"
            type="square-without-title"
        />
    </div>
</template>

<script lang="ts" setup>
import BaseLink from '@/components/BaseLink.vue'
import GameCard from '@/components/GameCard/GameCard.vue'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'
import { useGameAutoplayStore } from '@/pages/Games/autoplay-store'
import { ROUTE_NAMES } from '@/router/constants'
import type { LinkTarget, ShortGameType } from '@/types'

defineProps<{
    games: ShortGameType[]
    gameLinkTarget: LinkTarget | undefined
}>()

const gameAutoplayStore = useGameAutoplayStore()
</script>
<style module>
.games {
    display: flex;
    gap: 8px;
    scrollbar-width: none;
    overflow: auto;
    scroll-snap-type: x mandatory;
    padding-left: var(--global-wide-scroller-padding-left);
    padding-right: var(--global-wide-scroller-padding-right);
    height: 100%;
}

.games > * {
    flex-shrink: 0;
}

.my_games_link {
    color: #be8cff;
    background-color: var(--experimental-purple-graphit);
    height: 100%;
    border-radius: 8px;
    --sqrcl: 16rem;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 4px 0 8px;
    text-transform: uppercase;
    width: min-content;
}

.my_games_link_label {
    font-size: 11px;
}

.game {
    width: 56px;
    height: 56px;
}

.my_games_link:hover,
.game:hover {
    opacity: 0.8;
}
</style>
